var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon24PxFolderNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.56 4c1.276-.005 2.415.797 2.84 2l.32 1H18c1.657 0 3 1.343 3 3v7c0 1.657-1.343 3-3 3H6c-1.657 0-3-1.343-3-3V7c0-1.657 1.343-3 3-3zM12 10c-.552 0-1 .448-1 1v1h-1c-.552 0-1 .448-1 1s.448 1 1 1h1v1c0 .552.448 1 1 1s1-.448 1-1v-1h1c.552 0 1-.448 1-1s-.448-1-1-1h-1v-1c0-.552-.448-1-1-1zm7 7c0 .552-.448 1-1 1H6c-.552 0-1-.448-1-1V7c0-.552.448-1 1-1h4.56c.43-.001.812.273.95.68l.54 1.64c.138.407.52.681.95.68h5c.552 0 1 .448 1 1v7z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon24PxFolderNew);
export default __webpack_public_path__ + "static/media/4-icon-24-px-folder-new.1026d7d4.svg";
export { ForwardRef as ReactComponent };